import styled from 'styled-components'

import {ReactComponent as Arrow} from './picker-arrow.svg'
// import {Marginals} from '../../styles'

// export const colorP = styled.p`
//   position: fixed;
// `

export const ColorInput = styled.input`
  border-radius: 50%;
  width: 2em;
  height: 2em;
  padding: 0.5em;

  border: 0.5px solid black;

  /* &::after {
    content: '';

    width: 1.2em;
    height: 1.2em;

    border: 1px solid black;
  } */
`

export const Panel = styled.div.attrs(({$showColorPicker, bgColor}) => ({
  style: {
    right: $showColorPicker ? '0' : '-15rem',

    backgroundColor: bgColor
  }
}))`
  transition: right 1s;

  box-shadow: var(--clr-shadow) 0 0 1rem;
  position: absolute;
  top: 10vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0em;
  z-index: 200;

  @media (max-width: 48rem) {
    bottom: 0;
  }
`

export const InputContainer = styled.div.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  display: flex;
  justify-content: space-evenly;
  padding: 0;
`
export const ArrowButton = styled(Arrow).attrs(({$showColorPicker}) => ({
  style: {
    transform: $showColorPicker ? 'rotate(180deg)' : 'none'
  }
}))`
  transition: transform 1s;

  cursor: pointer;
  padding: 1rem;
`
export const InputParagraph = styled.div`
  padding: 1rem;
`
